export enum GpsCardStatus {
  AllGood = '00',
  ReferToCardIssuer = '01', // do not use
  CardNotYetActivated = '02',
  CaptureCard = '04',
  DoNotHonour = '05',
  InvalidCard = '14', // never set a card to this status
  LostCard = '41',
  StolenCard = '43',
  ClosedAccount = '46',
  ExpiredCard = '54',
  TransactionNotPermittedToCardholder = '57',
  SuspectedFraud = '59',
  RestrictedCard = '62',
  SecurityViolation = '63',
  CardholderToContactIssuer = '70',
  AllowableNumberOfPinTriesExceeded = '75',
  CardDestroyed = '83', // irreversible
  RefundGivenToCustomer = '98',
  CardVoided = '99',
  ShortTermBlock = 'G1',
  ShortTermFullBlock = 'G2',
  LongTermBlock = 'G3',
  LongTermFullBlock = 'G4',
}


export class GpsCardStatusHelper {

  public static getIcon1(statusString: string): string {
    const s = statusString as GpsCardStatus;
    return this.getIcon(s);
  }
  public static getText1(statusString: string): string {
    const s = statusString as GpsCardStatus;
    return this.getText(s);
  }

  public static getIcon(status: GpsCardStatus): string {

    switch (status) {
      case GpsCardStatus.AllGood:
        return '🟢';
      case GpsCardStatus.ReferToCardIssuer:
        return '🟡';
      case GpsCardStatus.CardNotYetActivated:
        return '🟡';
      case GpsCardStatus.CaptureCard:
        return '🔴';
      case GpsCardStatus.DoNotHonour:
        return '🔴';
      case GpsCardStatus.InvalidCard:
        return '🔴';
      case GpsCardStatus.LostCard:
        return '🟡';
      case GpsCardStatus.StolenCard:
        return '🟠';
      case GpsCardStatus.ClosedAccount:
        return '⚫️';
      case GpsCardStatus.ExpiredCard:
        return '🕐';
      case GpsCardStatus.TransactionNotPermittedToCardholder:
        return '🟡';
      case GpsCardStatus.SuspectedFraud:
        return '🔴';
      case GpsCardStatus.RestrictedCard:
        return '🔴';
      case GpsCardStatus.SecurityViolation:
        return '🔴';
      case GpsCardStatus.CardholderToContactIssuer:
        return '🔴';
      case GpsCardStatus.AllowableNumberOfPinTriesExceeded:
        return '🟨';
      case GpsCardStatus.CardDestroyed:
        return '🔴';
      case GpsCardStatus.RefundGivenToCustomer:
        return '🔴';
      case GpsCardStatus.CardVoided:
        return '◻️';

      case GpsCardStatus.ShortTermBlock:
        return '🟡';
      case GpsCardStatus.ShortTermFullBlock:
        return '🟡';

      case GpsCardStatus.LongTermBlock:
        return '⛔️';
      case GpsCardStatus.LongTermFullBlock:
        return '⛔️';
    }
    /*
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.AllGood">🟢 All Good</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.ReferToCardIssuer">🟡 Refer to card issuer</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.CardNotYetActivated">🟡 Card not yet activated</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.CaptureCard">🔴 Capture card</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.DoNotHonour">🔴 Do not honour</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.InvalidCard">🔴 Invalid card</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.LostCard">🟡 Lost card</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.StolenCard">🟠 Stolen card</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.ClosedAccount">⚫️ Closed Account</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.ExpiredCard">⚪️ Expired card</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.TransactionNotPermittedToCardholder">🟡 Transaction not permitted to cardholder</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.SuspectedFraud">🔴 Suspected fraud</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.RestrictedCard">🔴 Restricted card</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.SecurityViolation">🔴 Security violation</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.CardholderToContactIssuer">🔴 Cardholder to contact issuer</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.AllowableNumberOfPinTriesExceeded">Allowable number of PIN tries exceeded</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.CardDestroyed">🔴 Card destroyed</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.RefundGivenToCustomer">🔴 Refund given to customer</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.CardVoided">⚫️ Card voided</span>

    <span *ngIf="currentGpsStatusCached == gpsCardStatus.ShortTermBlock">🟡 Short Term Block</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.ShortTermFullBlock">🟡 Short Term Full Block</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.LongTermBlock">🟠 Long Term Block</span>
    <span *ngIf="currentGpsStatusCached == gpsCardStatus.LongTermFullBlock">🟠 Long Term Full Block</span>
    */
    return '⚪️';
  }

  public static getText(status: GpsCardStatus): string {


    switch (status) {
      case GpsCardStatus.AllGood:
        return 'All good';
      case GpsCardStatus.ReferToCardIssuer:
        return 'Refer to card issuer';
      case GpsCardStatus.CardNotYetActivated:
        return 'Card not yet activated';
      case GpsCardStatus.CaptureCard:
        return 'Capture card';
      case GpsCardStatus.DoNotHonour:
        return 'Do not honour';
      case GpsCardStatus.InvalidCard:
        return 'Invalid card';
      case GpsCardStatus.LostCard:
        return 'Lost card';
      case GpsCardStatus.StolenCard:
        return 'Stolen card';
      case GpsCardStatus.ClosedAccount:
        return 'Closed account';
      case GpsCardStatus.ExpiredCard:
        return 'Expired card';
      case GpsCardStatus.TransactionNotPermittedToCardholder:
        return 'Transaction not permitted to card holder';
      case GpsCardStatus.SuspectedFraud:
        return 'Suspected fraud';
      case GpsCardStatus.RestrictedCard:
        return 'Restricted card';
      case GpsCardStatus.SecurityViolation:
        return 'Security violation';
      case GpsCardStatus.CardholderToContactIssuer:
        return 'Cardholder to contact issuer';
      case GpsCardStatus.AllowableNumberOfPinTriesExceeded:
        return 'Allowable number of pin tries exceeded';
      case GpsCardStatus.CardDestroyed:
        return 'Card destroyed';
      case GpsCardStatus.RefundGivenToCustomer:
        return 'Refund given to customer';
      case GpsCardStatus.CardVoided:
        return 'Card voided';

      case GpsCardStatus.ShortTermBlock:
        return 'Short term block';
      case GpsCardStatus.ShortTermFullBlock:
        return 'Short term full block';

      case GpsCardStatus.LongTermBlock:
        return 'Long term block';
      case GpsCardStatus.LongTermFullBlock:
        return 'Long term full block';
    }

    return status;
  }
}
